import { Popover, Tag } from "@bedrock/components";
import { TagColor } from "@bedrock/components/lib/Tag";
import { Clock } from "@bedrock/icons-react";
import React from "react";

/**
 *  待确认 AWAIT_CONFIRM = 'AWAIT_CONFIRM',
 *  已确认 CONFIRMED = 'CONFIRMED',
 *  已拒绝 REJECTED = 'REJECTED',
 *  未确认 UN_CONFIRMED = 'UN_CONFIRMED',
 */
type STATUS = 
  /** 待确认 */
  'AWAIT_CONFIRM' |
  /** 已确认 */
  'CONFIRMED' |
  /** 已拒绝 */
  'REJECTED' |
  /** 未确认 */
  'UN_CONFIRMED';

const STATUS_MAP: Record<STATUS, { name: string, color: TagColor }> = {
  AWAIT_CONFIRM: {
    name: '待确认',
    color: 'light-orange',
  },
  CONFIRMED: {
    name: '已确认',
    color: 'light-green',
  },
  REJECTED: {
    name: '已拒绝',
    color: 'light-red',
  },
  UN_CONFIRMED: {
    name: '未确认',
    color: 'light-grey',
  }
}

interface OperateStatusTagProps extends React.ComponentProps<typeof Tag> {
  statusName?: string;
  operateTime?: string;
  operateTimeLabel?: string;
  status?: STATUS;
}

export default function OperateStatusTag({ status = 'AWAIT_CONFIRM', statusName, operateTime, operateTimeLabel, ...rest }: OperateStatusTagProps) {
  const conf = STATUS_MAP[status];
  return (
    <Tag
      size="small"
      color={conf?.color}
      {...rest}
      text={
        <Popover
          content={
            <div>
              <p>{operateTimeLabel}：</p>
              <p>{operateTime}</p>
            </div>
          }
          placement="top"
          visible={operateTime ? undefined : false}
        >
          <span>
            {statusName || conf?.name}
            {operateTime && <Clock className="m-l-2"/>}
          </span>
        </Popover>
      }
    />
  )
}